<template>

<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M332.031,0c-99.234,0-179.968,80.734-179.968,179.968c0,44.23,16.048,84.776,42.614,116.144l-31.26,31.26
			c-16.721-7.965-37.375-5.043-51.199,8.78l-99.062,99.061c-17.541,17.542-17.541,46.086,0,63.629
			c17.543,17.542,46.087,17.542,63.629,0l99.061-99.061c14.028-14.027,16.696-34.722,8.799-51.219l31.241-31.241
			c31.368,26.566,71.914,42.614,116.144,42.614c99.234,0,179.968-80.734,179.968-179.968S431.267,0,332.031,0z M154.637,378.573
			l-99.061,99.062c-5.847,5.847-15.361,5.848-21.209,0s-5.848-15.362,0-21.21l99.062-99.061c5.848-5.848,15.361-5.848,21.209,0
			C160.498,363.224,160.498,372.71,154.637,378.573z M332.031,329.941c-82.695,0-149.973-67.278-149.973-149.973
			S249.336,29.995,332.031,29.995s149.973,67.278,149.973,149.973S414.728,329.941,332.031,329.941z"/>
	</g>
</g>
<g>
	<g>
		<path d="M427.281,120.934c-7.754-2.908-16.4,1.021-19.309,8.776l-30.95,82.532l-30.949-82.532
			c-4.852-12.939-23.232-12.943-28.085,0l-30.949,82.532l-30.95-82.532c-2.908-7.756-11.555-11.685-19.309-8.776
			c-7.756,2.908-11.685,11.553-8.776,19.309l44.992,119.979c4.852,12.939,23.232,12.943,28.085,0l30.95-82.532l30.949,82.532
			c4.852,12.939,23.232,12.943,28.085,0l44.992-119.979C438.966,132.486,435.037,123.842,427.281,120.934z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
